import Dashboards from '@highcharts/dashboards';
import DataPoolOptions from '@highcharts/dashboards/es-modules/Data/DataPoolOptions';
import ChartStackedColumn from '../Charts/ChartStackedColumn';
import SubChartBar from '../Charts/SubCharts/SubChartBar';
import { EditModeConfig, GuiConfig, DashboardConfig, SUB_CHART_LIMIT, dateAggregationMap } from './DefaultConfig';
import { DataFunctions } from '../../Utils/dataFunctions';

const seriesColorMapping: { [key: string]: string } = {
  'Initial Consult': '#AAA1FD',
  'Follow Up': '#3EA7B2',
  'Sim Education': '#FFBD5B',
  'Treatment Review': '#FB6A76',
};

const Consultations = ({
  data,
  subChartData,
  seeMoreBottomLeft,
  seeMoreBottomRight,
  dateRange,
  ...rest
}: DashboardConfig): Dashboards.Board.Options => ({
  dataPool: dataPoolConfig(data, subChartData, seeMoreBottomLeft, seeMoreBottomRight, dateRange),
  editMode: EditModeConfig,
  gui: GuiConfig,
  components: [
    ChartStackedColumn({
      selectedPoint: rest.filterOverride,
      aggregation: dateAggregationMap[dateRange!],
      dateRange: dateRange,
      leftSeriesTitle: '',
      rightSeriesTitle: '',
      leftSeriesFields: DataFunctions.aggregateStackedBarData(
        data,
        'appointment.appointmentType',
        dateAggregationMap[dateRange!],
        '',
        ['Initial Consult', 'Follow Up', 'Sim Education', 'Treatment Review'],
        true,
      )[0],
      rightSeriesFields: ['submittedAt', 'Techniques'],
      seriesColorMapping,
      tooltipSuffix: 'cases',
      ...rest,
    }).components?.[0] ?? {},
    SubChartBar({
      seeMore: seeMoreBottomLeft,
      title: 'Diagnosis Codes',
      connector: 'sub-chart-left-data',
      cell: 'sub-chart-left',
      yAxisMax: DataFunctions.aggregateDataMax(subChartData, 'diagnosisCode') * 2,
      dataLength: DataFunctions.aggregateData(subChartData, 'diagnosisCode').length - 1,
      dataTotal: DataFunctions.aggregateDataSum(subChartData, 'diagnosisCode'),
      ...rest,
    }).components?.[0] ?? {},
    SubChartBar({
      seeMore: seeMoreBottomRight,
      title: 'Referring Physicians',
      connector: 'sub-chart-right-data',
      cell: 'sub-chart-right',
      yAxisMax: DataFunctions.aggregateDataMax(subChartData, 'createdBy') * 2,
      dataLength: DataFunctions.aggregateData(subChartData, 'createdBy').length - 1,
      dataTotal: DataFunctions.aggregateDataSum(subChartData, 'createdBy'),
      ...rest,
    }).components?.[0] ?? {},
  ],
});

const dataPoolConfig = (
  data: any,
  subChartData: any,
  seeMoreBottomLeft: boolean,
  seeMoreBottomRight: boolean,
  dateRange: string | undefined,
): DataPoolOptions => ({
  connectors: [
    {
      id: 'top-chart-data',
      type: 'JSON',
      options: {
        firstRowAsNames: true,
        data: DataFunctions.aggregateStackedBarData(
          data,
          'appointment.appointmentType',
          dateAggregationMap[dateRange!],
          '',
          [],
          true,
        ),
      },
    },
    {
      id: 'sub-chart-left-data',
      type: 'JSON',
      options: {
        data: DataFunctions.aggregateData(
          subChartData,
          'diagnosisCode',
          seeMoreBottomLeft ? undefined : SUB_CHART_LIMIT,
        ),
      },
    },
    {
      id: 'sub-chart-right-data',
      type: 'JSON',
      options: {
        data: DataFunctions.aggregateData(subChartData, 'createdBy', seeMoreBottomRight ? undefined : SUB_CHART_LIMIT),
      },
    },
  ],
});

export default Consultations;
